<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12.9576 8.68793V9.71295C12.9576 10.1785 12.5789 10.5573 12.1133 10.5573H10.785C10.3195 10.5573 9.9407 10.1785 9.9407 9.71295V8.68793H5.9382V9.71295C5.9382 10.1785 5.55945 10.5573 5.0939 10.5573H3.76556C3.30002 10.5573 2.92126 10.1785 2.92126 9.71295V8.68793H0.46875V13.8013C0.46875 14.3773 0.937134 14.846 1.51318 14.846H14.4243C15.0004 14.846 15.4688 14.3773 15.4688 13.8013V8.68793H12.9576ZM12.0787 7.40179H10.8196V9.67834H12.0787V7.40179ZM14.4243 3.74609H1.51318C0.937134 3.74609 0.46875 4.21448 0.46875 4.79053V7.80902H2.92126V7.36728C2.92126 6.90173 3.30002 6.52289 3.76556 6.52289H5.0939C5.55945 6.52289 5.9382 6.90173 5.9382 7.36728V7.80902H9.9407V7.36728C9.9407 6.90173 10.3195 6.52289 10.785 6.52289H12.1133C12.5789 6.52289 12.9576 6.90173 12.9576 7.36728V7.80902H15.4688V4.79053C15.4688 4.21448 15.0004 3.74609 14.4243 3.74609ZM3.80017 7.40179V9.67834H5.0593V7.40179H3.80017Z"
        fill="currentColor"/>
    <path
        d="M5.16016 2.86478V2.18861C5.16016 2.05871 5.26691 1.95306 5.39829 1.95306H10.5399C10.6712 1.95306 10.778 2.05871 10.778 2.18861V2.86478H11.6569V2.18861C11.6569 1.57406 11.1559 1.07422 10.5399 1.07422H5.39829C4.78232 1.07422 4.28125 1.57425 4.28125 2.18861V2.86478H5.16016Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconCase"
}
</script>

<style scoped>

</style>